import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { composeFunctions, useClassNames } from '../utils';
import { setMonth, setYear } from '../utils/dateUtils';
import { useCalendarContext } from './CalendarContext';
var MonthDropdownItem = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
      Component = _props$as === void 0 ? 'div' : _props$as,
      className = props.className,
      _props$classPrefix = props.classPrefix,
      classPrefix = _props$classPrefix === void 0 ? 'calendar-month-dropdown-cell' : _props$classPrefix,
      active = props.active,
      disabled = props.disabled,
      _props$month = props.month,
      month = _props$month === void 0 ? 0 : _props$month,
      year = props.year,
      rest = _objectWithoutPropertiesLoose(props, ["as", "className", "classPrefix", "active", "disabled", "month", "year"]);

  var _useCalendarContext = useCalendarContext(),
      date = _useCalendarContext.date,
      onSelect = _useCalendarContext.onChangeMonth;

  var handleClick = useCallback(function (event) {
    if (disabled) {
      return;
    }

    if (year && month && date) {
      var nextMonth = composeFunctions(function (d) {
        return setYear(d, year);
      }, function (d) {
        return setMonth(d, month - 1);
      })(date);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(nextMonth, event);
    }
  }, [date, disabled, month, onSelect, year]);

  var _useClassNames = useClassNames(classPrefix),
      prefix = _useClassNames.prefix,
      merge = _useClassNames.merge,
      withClassPrefix = _useClassNames.withClassPrefix;

  var classes = merge(className, withClassPrefix({
    active: active
  }), {
    disabled: disabled
  });
  return /*#__PURE__*/React.createElement(Component, _extends({}, rest, {
    ref: ref,
    className: classes,
    onClick: handleClick,
    key: month,
    tabIndex: -1
  }), /*#__PURE__*/React.createElement("span", {
    className: prefix('content')
  }, month));
});
MonthDropdownItem.displayName = 'MonthDropdownItem';
MonthDropdownItem.propTypes = {
  month: PropTypes.number,
  year: PropTypes.number,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool
};
export default MonthDropdownItem;